import React from 'react';
import PropTypes from 'prop-types';
import UserIcon from './UserIcon';
import LocaleIcon from '../locale/LocaleIcon';
import getCurrentLocale from '../../utils/localeUtils';

export default class MobileMenuButtons extends React.Component {
    static propTypes = {
        isLocaleActive: PropTypes.bool,
        locale: PropTypes.string,
        localeOptions: PropTypes.array,
        isLoggedIn: PropTypes.bool,
        hideLocale: PropTypes.bool,
        hideSignIn: PropTypes.bool,
        mobileUserActive: PropTypes.bool,
        signInLinks: PropTypes.array,
        displayName: PropTypes.string
    };

    static contextTypes = {
        messages: PropTypes.object
    };

    render() {
        const {currentLocale} = getCurrentLocale(this.props.localeOptions, this.props.locale, this.context.messages.locale);

        let hideLocale = this.props.hideLocale;
        if (!hideLocale) {
            if (!this.props.localeOptions || !this.props.localeOptions.length || this.props.localeOptions.length === 1) {
                console.warn('[EGH] localeOptions array was invalid or empty. Hiding locale...');
                hideLocale = true;
            }
        }

        let hideSignIn = this.props.hideSignIn;
        if (!hideSignIn) {
            if (!this.props.signInLinks || !this.props.signInLinks.length) {
                console.warn('[EGH] signInLinks array was invalid or empty. Hiding the signIn...');
                hideSignIn = true;
            }
        }

        return (
            <div className="mobile-buttons">
                {!hideSignIn ?
                    <UserIcon
                        isLoggedIn={this.props.isLoggedIn}
                        mobileUserActive={this.props.mobileUserActive}
                        signInLinks={this.props.signInLinks}
                        displayName={this.props.displayName} />
                    : <span />}
                {!hideLocale ?
                    <LocaleIcon
                        currentLocale={currentLocale}
                        isActive={this.props.isLocaleActive} /> : <span />}
            </div>
        );
    }
}
